import React from 'react'
import { Route } from 'react-router-dom'
import { EmailActivityPage } from '../../../../shared/email-activity/email-activity-page'

// Email activity on the organization's own page: the signed-in
// organization's email only, for everyone, super admins included (owner
// direction 2026-10-07: every organization's email lives in the staff
// Internal tools). The page asks the server for the organization view, and
// shows no Organization column or filter.
export const LayoutOrgEmailActivity = () => {
  return (
    <React.Fragment>
      <Route path="/org/email-activity">
        <EmailActivityPage />
      </Route>
    </React.Fragment>
  )
}
